import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ChargeLongFormBuilderSectionRescore($id: ID!) {
    chargeLongFormBuilderSectionRescore(id: $id)
  }
`;

export const chargeLongFormBuilderSectionRescore = (id) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
